jQuery(document).ready(function ($) {
	"use strict";

	/**
	 * Counter
	 */
    $('.counter-item .number').each(function () {
		var $this = $(this),
			sectionOffset = $this.closest('.counters-block').offset().top,
			itemNum = $this.text();

		$(window).on('scroll', function(){
			if ( $(window).scrollTop() > sectionOffset - $(window).height() * 2 ) {
				$this.animate({
					itemNum
				}, {
					duration: 4000,
					easing: 'swing',
					step: function (now) {
						now = Number(Math.ceil(now)).toLocaleString("de-DE");
						$this.text(now);
					},
					complete: function() {
						$this.text(itemNum);
					}
				});
			}
		});
	});

	$(window).trigger('scroll');
});
